import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { concatStrings } from '../utilities';
import { Image } from 'cloudinary-react'

const DfbImage = (props) => {

  if (!props.image || !props.image.src) {
    return null;
  }

  let ratioClass = ''

  switch (props.aspect_ratio) {
    case '16:9':
      ratioClass= ''
      break
    case '4:3':
      ratioClass= 'dfb-Image--4To3Ratio'
      break
    case '3:4':
      ratioClass= 'dfb-Image--3To4Ratio'
      break
    case '3:1':
      ratioClass= 'dfb-Image--3To1Ratio'
      break
    case '2:3':
      ratioClass= 'dfb-Image--2To3Ratio'
      break
    case '1:1':
      ratioClass= 'dfb-Image--1To1Ratio'
      break
    default:
      ratioClass= ''
      break
  }

  let overlayClass = ''

  switch (props.overlay) {
    case '55':
      overlayClass = 'dfb-Image--overlay dfb-Image--opacity55'
      break
    case '75':
      overlayClass = 'dfb-Image--overlay dfb-Image--opacity75'
      break
    case '90':
      overlayClass = 'dfb-Image--overlay dfb-Image--opacity90'
      break
    default:
      overlayClass = ''
      break
  }

  const lazyloadingClass = ( props.lazyload ? 'dfb-Image--lazyloading' : '')
  const coverClass = ( props.cover ? 'dfb-Image--cover' : '')

  let imgHtml = ''
  let imgPlaceholderBase64 = process.env.LAZYLOAD_IMAGE_PLACEHOLDER

  // no cloudinary image for data URLs and SVGs
  if (/^data:|\.svg$/.test(props.image.src)) {
    imgHtml = ReactDOMServer.renderToStaticMarkup(
      <img
        src={props.image.src}
        className="dfb-Image-image"
        title={props.image.title}
        alt={props.image.alternative}
        data-object-fit
      >
      </img>
    )
  } else {
    const imgEl = <Image
      publicId={props.image.src}
      className="dfb-Image-image"
      title={props.image.title}
      alt={props.image.alternative}
      data-object-fit
      type="fetch"
      cloudName={process.env.CLOUDINARY_CLOUD_NAME}
      secure="true"
    >
      {props.children}
    </Image>
    imgHtml = ReactDOMServer.renderToStaticMarkup(imgEl)
    if (props.lazyload) {
      imgHtml = imgHtml.replace(
        "src=",
        'src="' + imgPlaceholderBase64 + '" data-src='
      )
    }
  }



  return (
    <div className={concatStrings('dfb-Image', ratioClass, overlayClass, lazyloadingClass, coverClass, props.add_class)}
      dangerouslySetInnerHTML={{
        __html: imgHtml
      }}
    >

    </div>
  );
}

DfbImage.defaultProps = {
  lazyload: true,
  cover: false
}

export default DfbImage;
